module.exports = __webpack_public_path__ + "img/prizes.20aa9f30.png";